import HttpService from "../Http/HttpService";
import Logger from "../Logger/Logger";
import Validator from "../Validator/Validator";
import { API_LOGIN, API_LOGIN_RESPONSE_FAILED, API_LOGIN_RESPONSE_SUCCESSFUL, API_LOGIN_RESPONSE_WRONG_CREDENTIALS, API_LOGOUT } from "./AuthenticationConstants";
import { bootstrapAuth } from "./BootstrapAuth";
import { LoginPojo } from "./AuthenticationPojo/LoginPojo";
import { Store } from "../../app/store";
import { clearAuth } from "../../features/authSlice";
import { AUTH_HINT } from "../../Constant";

export class Authentication {
    private httpService = new HttpService();
    private logger = new Logger();
    private validator = new Validator();

    
    async login(data : LoginPojo) : Promise<string> {
        try {
            let result = API_LOGIN_RESPONSE_SUCCESSFUL;
            this.validator.isValidString('email', data.email);
            this.validator.isValidString('password', data.password);
            const response = await this.httpService.post(API_LOGIN, data);
            if(response.status && response.data.isSuccess){
                await bootstrapAuth();
                localStorage.setItem(AUTH_HINT, "1");
            } else {
                if(response.data.response.error === "INVALID_EMAIL_OR_PASSWORD"){
                    result = API_LOGIN_RESPONSE_WRONG_CREDENTIALS;
                } else {
                    result = API_LOGIN_RESPONSE_FAILED;
                }
            }
            return result;
        } catch (e){
            this.logger.error(e);
            throw e;
        }
    }

    async logout(): Promise<boolean> {
        try {
            const response = await this.httpService.post(API_LOGOUT, {});
            if(response.status && response.data.isSuccess){
                localStorage.removeItem(AUTH_HINT);
                Store.dispatch(clearAuth());
            }
            return false;
        } catch (e) {
            this.logger.error(e);
            Store.dispatch(clearAuth());
            return false;
        }
    }

}